export default {
	login: 'Anmelden',
	loginHeadline:
		'Willkommen im HÄVG-Herstellerportal der Hausärztlichen Vertragsgemeinschaft AG',
	passwordForget: 'Passwort vergessen',
	requestAccount: 'Benutzerregistrierung anfordern',
	email: 'E-Mail-Adresse',
	password: 'Passwort',
	emailRequired: 'Geben Sie bitte eine E-Mail-Adresse an.',
	passwordRequired: 'Passwort ist erforderlich.',
	invalidCredentials: 'Ungültige Anmeldeinformationen',
	validations: {
		email: 'Eine gültige E-Mail-Adresse ist erforderlich.'
	},
	footer: {
		impressum: 'Impressum',
		sealTerms: 'HZV-Prüfsiegel-Bestimmungen',
		privacyPolicy: 'Datenschutzerklärung',
		termsOfUse: 'Nutzungsbedingungen'
	},
	registrationRequestPage: {
		registration: 'Registrierung',
		info: 'Bitte registrieren Sie sich mit Ihrer geschäftlichen E-Mail-Adresse, um einen HÄVG-Herstellerportal Zugang zu erhalten.\nSie erhalten anschließend eine E-Mail mit weiteren Anweisungen zur Freischaltung Ihres Benutzerkontos.\nBitte geben Sie Ihre Daten für die Registrierung ein: ',
		firstName: 'Vorname',
		firstNameRequired: 'Vorname erforderlich',
		lastName: 'Nachname',
		lastNameRequired: 'Nachname erforderlich',
		captchaLabel: 'Sicherheitscode',
		captchaPlaceholder: 'Code eingeben',
		captchaRefresh: 'Neuen Code anzeigen',
		captchaImageAlt: 'Sicherheitscode',
		captchaLoading: 'Code wird geladen...',
		captchaRequired: 'Bitte geben Sie den Sicherheitscode ein.',
		captchaNotLoaded:
			'Der Sicherheitscode konnte nicht geladen werden. Bitte erneut versuchen.',
		captchaInvalid:
			'Der Sicherheitscode ist ungültig. Bitte versuchen Sie es erneut.',
		confirmPassword: 'Passwort wiederholen',
		submitRegistrationRequest: 'Registrierung anfordern',
		thankYou: 'Vielen Dank!',
		successMessage:
			'Wir haben Ihre Registrierung erhalten.\nDie Prüfung und Bearbeitung kann etwas Zeit in Anspruch nehmen.\nNach der Prüfung erhalten Sie eine E-Mail mit weiteren Informationen.\nIhr AKA-Supportteam',
		errorMessage:
			'Bei der Registrierung ist leider ein Problem aufgetreten. Bitte versuchen Sie es später erneut.'
	},
	passwordRequestPage: {
		headline:
			'Bitte geben Sie Ihre E-Mail-Adresse ein, um ein neues Passwort anzufordern. Sie erhalten anschließend eine E-Mail mit weiteren Anweisungen zum Zurücksetzen Ihres Passworts.'
	},
	passwordResetRequestForm: {
		messages: {
			success:
				'Bitte überprüfen Sie Ihr Postfach inkl. des Spam-Filters für weitere Anweisungen',
			error: 'Leider ist etwas schief gelaufen. Versuchen Sie es später erneut'
		}
	},
	passwordResetConfirmPage: {
		headline:
			'Bitte geben Sie Ihr neues Passwort ein, um Ihr Konto wiederherzustellen.'
	},
	passwordResetConfirmForm: {
		messages: {
			success:
				'Ihr Passwort wurde erfolgreich geändert. Sie können sich nun mit dem neuen Passwort anmelden',
			error: 'Ihr Passwort konnte nicht geändert werden - {{message}}'
		}
	},
	backToLogin: 'Zurück zur Anmeldung'
}
